'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import LoginForm from './components/LoginForm';
import { isAuthenticated } from '@/lib/authStore';

export default function LoginPage() {
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated()) {
      router?.replace('/');
    }
  }, [router]);

  return <LoginForm data-component-id="src/app/login-screen/page.tsx:17:9" data-component-path="src/app/login-screen/page.tsx" data-component-line="17" data-component-end-line="17" data-component-file="page.tsx" data-component-name="LoginForm" data-component-content="%7B%22elementName%22%3A%22LoginForm%22%7D" />;
}